import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

import { ListViewComponent } from '../../list-view/list-view.component';
import { GridViewComponent } from '../../grid-view/grid-view.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommanService } from '../../../_services/comman.service';
import { ListviewGridviewHeaderComponent } from '../../listview-gridview-header/listview-gridview-header.component';
import { DatasearchService } from '../../../_services/datasearch.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { ConstantService } from '../../../_services/constant.service';
import { user_privilege } from '../../../../_model/user_privilege';
import { BusyService } from '../../../_services/busy.service';
import { Router } from '@angular/router';
import {
  auditTime,
  BehaviorSubject,
  combineLatest,
  distinctUntilChanged,
  skip,
  Subject,
  Subscription,
  UnsubscriptionError,
} from 'rxjs';
@Component({
  selector: 'app-gapd',
  standalone: true,
  imports: [
    CommonModule,
    ListviewGridviewHeaderComponent,
    ListViewComponent,
    GridViewComponent,
    FormsModule,
  ],
  templateUrl: './gapd.component.html',
  styleUrl: './gapd.component.scss',
})
export class GapdComponent {
  currViewType!: string;
  user_data: any;
  privilege_json!: user_privilege;
  currColumns: any[] = [];

  isFullScreen: boolean = false;
  totalRecords: any;
  isListView: boolean = true;
  productDetails: boolean = false;
  cols: any[] = [];
  products_current_datasource: any[] = [];
  rows: number = 50;
  countries: any[] = [];
  cropCommodities: any[] = [];
  selectedCountry: string = 'View All';
  selectedCrop: string = 'View All';
  loading_table = false;
  TableRowsCounts: number[] = [5, 10, 20, 25, 50, 100, 150];
  tablefilter: any = {};
  patentTypes: any[] = [];
  mrlTableFliters!: any;
  dateValue: any = {};
  searchedWords: string[] = [];
  current_GBRN: any = 0;

  oldSearchQueryGrid = '';
  serialStart: number = 0;
  matchModeOptions: any = [
    { label: 'Select Filter', value: 'select' },
    { label: 'Date is', value: 'dateIs' },
    { label: 'Date is not', value: 'dateIsNot' },
    { label: 'Date is before', value: 'dateBefore' },
    { label: 'Date is after', value: 'dateAfter' },
  ];
  detailViewTabs = [
    { header: 'BIBLIOGRAPHY', field: '' },
    { header: 'description', field: 'description' },
    { header: 'CLAIMS', field: 'claims' },
    { header: 'PATENT FAMILY', field: 'patent_familf' },
    { header: 'SPC', field: 'spc' },
    { header: 'ORANGE BOOK (OB) PATENTS', field: 'dummy2' },
  ];
  isShowReadMoreDialog: boolean = false;
  readMoreColumn: string = '';
  readMoreContent: string = '';
  detailViewData: any = {};
  updatePrivilege = false;
  oldResult: any = {};
  current_pagenumber: number = 1;
  selectedDetailViewIndex = 0;
  pageLimitInPrivilegeJson: number = 0;
  dynSelectedPatentType: string = '';
  pageLimitInDatabaseLimit: number = 0;
  totalpages: any = 0;
  selectedPage: number = 1;
  searched = true;
  currentFliter: any = {};
  resultData: any[] = [];
  resultTotal: number = 0;
  resultCountries: any[] = [];
  resultCompanies: any[] = [];

  currCountry: string = '';
  currCriteria: any[] = [];
  currPagenumber: number = 1;
  currRowsCount: number = 15;
  currShortBy: string = '';
  currFilters: any[] = [];
  currSelectedSubFilterCountry: string = '';
  currSelectedSubFilterCompany: string = '';
  currSortField: string = '';
  currSortOrder: string = '';
  first = 0;
  currentSortBy: string = '';
  listSortByfield: string = '';
  listSortOrder: string = 'ASC';
  noRecordFound: boolean = false;
  currResultData$ = new BehaviorSubject<any[]>([]);
  currResultTotal$ = new BehaviorSubject<number>(0);
  currResultCountries$ = new BehaviorSubject<any[]>([]);
  currResultCompanies$ = new BehaviorSubject<any[]>([]);
  constructor(
    private _commanService: CommanService,
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private commanService: CommanService,
    private busyService: BusyService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  // Get current view type
  ngOnInit(): void {
    // this.getUserPrivilege();
    this.commanService.getUserPrivilege().subscribe((res: any) => {
      this.privilege_json = res;
      console.log("privilege in gapd : ", this.privilege_json)
    });
    this.loadColumnDetails();
    this.commanService.currentgbrn.subscribe((gbrn_res: any) => {
      if (gbrn_res) {
        this.current_GBRN = gbrn_res;
        this.search_data();
      }
    });

    this._commanService.getViewType().subscribe((res) => {
      this.currViewType = res;
    });

    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error success false');
          }
        },
        (error: any) => {
          console.log('Error :', error);
        }
      );
    combineLatest([
      this._commanService.getSelectedSubFilterCountry(),
      this._commanService.getSelectedSubFilterCompany(),
      this._commanService.getPageNumber(),
      this._commanService.getLimit(),
      this._commanService.getSortField(),
      this._commanService.getSortOrder(),
      this._commanService.getFilter(),
    ])
      .pipe(
        skip(1),
        auditTime(0),
        distinctUntilChanged(
          (prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)
        )
      )
      .subscribe(
        ([country, company, page, limit, sortField, sortOrder, filters]) => {
          this.currSelectedSubFilterCountry = country;
          this.currSelectedSubFilterCompany = company;
          this.currPagenumber = page;
          this.currRowsCount = limit;
          this.currSortField = sortField;
          this.currSortOrder = sortOrder;
          this.currFilters = filters;

          this.search_data();
        }
      );
  }

  ngOnDestroy(): void {
    // Set current view type as "listView"
    this._commanService.setViewType('gridView');
  }
  // async getUserPrivilege(): Promise<void> {
  //   this.authentication.getCurrentUserValue().subscribe((val: any) => {
  //     console.log('[getUserPrivilege] - Current user data received:', val);

  // this.authentication.getCurrentUserSubject().subscribe((val) => {
  //   console.log('[getUserPrivilege] - Current user data received:', val);

  //     this.user_data = val;

  //     // ✅ Get stored privileges from localStorage
  //     const storedPrivileges = JSON.parse(
  //       localStorage.getItem('user_privilege') || '{}'
  //     );

  //     if (!storedPrivileges || Object.keys(storedPrivileges).length === 0) {
  //       console.warn(
  //         '[getUserPrivilege] - No user_privilege found in localStorage.'
  //       );
  //       return;
  //     }

  //     // ✅ App key for agropat privilege
  //     const appKey = 'agropat-ultimate-discovery-suite-beta';
  //     const privilegeData = storedPrivileges[appKey];

  //     if (!privilegeData) {
  //       console.warn(
  //         `[getUserPrivilege] - No privilege found for app: ${appKey}`
  //       );
  //       return;
  //     }

  //     console.log(
  //       `[getUserPrivilege] - Fetched privilege data for ${appKey}:`,
  //       privilegeData
  //     );

  //     // ✅ Store locally for this component
  //     this.privilege_json = privilegeData;

  //     // ✅ Push privilege data to CommanService (Reactive access)
  //     this.commanService.currentPrivilege.next(this.privilege_json);

  //     console.log(
  //       `[getUserPrivilege] - Privilege JSON pushed to commanService for ${appKey}.`
  //     );
  //   });
  // }

  search_data(isFilterApplied = false) {
    if (isFilterApplied) {
      this.selectedPage = 1;
      this.first = 0;
      this.commanService.currentPrivilege.next(1);
    }
    let sortby: string = '';
    if (this.currSortField && this.currSortOrder) {
      sortby = this.currSortField + ' ' + this.currSortOrder;
    }

    const postdata = {
      gbrn: this.current_GBRN || '',
      // country: this.currCountry,
      pagenumber: this.currPagenumber,
      rowscount: this.currRowsCount,
      sortby: sortby,
      filters: this.currFilters,
      subFilters: {
        country: this.currSelectedSubFilterCountry,
        company: this.currSelectedSubFilterCompany,
      },
    };
    this.busyService.busy();

    this.datasearch.getplatforgapddata(postdata).subscribe({
      next: (res: any) => {
        this.resultData = res.data.data || [];
        this.resultTotal = res.data.count;

        this.noRecordFound = this.resultData.length === 0;

        this.loading_table = false;

        this.resultCountries = [
          { label: 'All Country', value: 'View All' },
          ...res.data.countries.map((value: string) => ({
            label: value,
            value,
          })),
        ];
        this.resultCompanies = [
          { label: 'All Company', value: 'View All' },
          ...res.data.companies.map((value: string) => ({
            label: value,
            value,
          })),
        ];
        this.resultData.forEach((row, index) => {
          row.S_NO = (this.currPagenumber - 1) * this.currRowsCount + index + 1;
        });

        // Hide columns where all data is empty
        this.hideColumns(this.resultData);

        this.emitResults();
      },
      error: (error: any) => {
        this.products_current_datasource = [];
        this.totalRecords = 0;
        this.totalpages = 0;
        this.loading_table = false;
        this.noRecordFound = true; // treat error case as no record
        this.busyService.idle();
        this.cdr.detectChanges();
      },
      complete: () => {
        this.searched = true;
        this.loading_table = false;
        this.busyService.idle();
        this.cdr.detectChanges();
      },
    });
  }

  emitResults() {
    this._commanService.setResultData(this.resultData);

    this._commanService.setResultTotal(this.resultTotal);

    this._commanService.setResultCountries(this.resultCountries);

    this._commanService.setResultCompanies(this.resultCompanies);

    // this.hideColumns();
    // If you ever enable this line, add logging too:
    // console.log("📤 Emitting Searched Query:", this.searchedQueryAsString);
    // this._commanService.setSearchQueryAsStringy(this.searchedQueryAsString);

    // this.navigateToSection('platform/gapd-database');
  }

  navigateToSection(route: string) {
    // this._commanService.setCurrBreadCrumbValue({
    //   label,
    //   route,
    // });
    this.router.navigateByUrl(route);
  }

  // hideColumns() {
  //   let tempTableData = this.products_current_datasource;
  //   let tempCols = this.cols;

  //   this.cols.forEach((currCol) => {
  //     // For mrl_mongos columns
  //     if (
  //       currCol.field !== 'chemicalStructure' &&
  //       currCol.field !== 'iupac' &&
  //       currCol.field !== 'casRn' &&
  //       currCol.field !== 'chemicalClass' &&
  //       currCol.field !== 'smilesCode' &&
  //       currCol.field !== 'summaryPhysicochemPropComp' &&
  //       currCol.field !== 'summaryPhysicochemPropExperi' &&
  //       currCol.field !== 'indication'
  //     ) {
  //       let isAllFieldHaveData = tempTableData.every(
  //         (row) => !row[currCol.field]
  //       );

  //       // If all field not have data then hide it
  //       if (isAllFieldHaveData) {
  //         tempCols.forEach((col) => {
  //           if (col.field === currCol.field) {
  //             col.isDisplay = 0;
  //           }
  //         });
  //       }
  //     }
  //     // For basic_product_details_MONGO
  //     else {
  //       let hideColumn = false;
  //       tempTableData.forEach((row) => {
  //         let ads_data = row.gbrn_products;

  //         if (ads_data.length) {
  //           let isAllFieldHaveData_ads = ads_data.every(
  //             (obj: any) => !obj[currCol.field]
  //           );
  //           if (isAllFieldHaveData_ads) {
  //             hideColumn = true;
  //           } else {
  //             hideColumn = false;
  //           }
  //         } else {
  //           hideColumn = true;
  //         }
  //       });

  //       if (hideColumn) {
  //         tempCols.forEach((col) => {
  //           if (col.field === currCol.field) {
  //             col.isDisplay = 0;
  //           }
  //         });
  //       }
  //     }
  //   });

  //   this.cols = tempCols;
  // }
  loadColumnDetails() {

    this.datasearch.getGapdColumns().subscribe(
      (res: any) => {
        res.data.results.forEach((field: any) => {
          field.columnWidth = parseInt(field.columnWidth.replace('px', ''));
        });
        this.currColumns = res.data.results;

        this._commanService.setColumns(this.currColumns);
      },
      (error: any) => {
        console.error('Error loading column details:', error);
      }
    );
  }
  hideColumns(tableData: any[]) {
    let currColumns = this.commanService.getColumns_normal();
    let tempCols = this.commanService.getColumns_normal();

    currColumns.forEach((currCol) => {
      // For gapd_mongos columns
      if (
        currCol.field !== 'chemicalStructure' &&
        currCol.field !== 'iupac' &&
        currCol.field !== 'casRn' &&
        currCol.field !== 'chemicalClass' &&
        currCol.field !== 'mechanismOfActionMoa' &&
        currCol.field !== 'indication'
      ) {
        // Check if ALL rows have empty or null in this column field
        let isAllFieldHaveData = tableData.every((row) => !row[currCol.field]);

        if (isAllFieldHaveData) {
          tempCols.forEach((col) => {
            if (col.field === currCol.field) {
              col.isDisplay = 0; // hide
            }
          });
        }
      } else {
        // For complex sub-objects like gbrn_products
        let hideColumn = false;
        tableData.forEach((row) => {
          let ads_data = row.gbrn_products || [];

          if (ads_data.length) {
            let isAllFieldHaveData_ads = ads_data.every(
              (obj: any) => !obj[currCol.field]
            );
            if (isAllFieldHaveData_ads) {
              hideColumn = true;
            } else {
              hideColumn = false;
            }
          } else {
            hideColumn = true;
          }
        });

        if (hideColumn) {
          tempCols.forEach((col) => {
            if (col.field === currCol.field) {
              col.isDisplay = 0;
            }
          });
        }
      }
    });

    this.commanService.setColumns(tempCols);
  }
}
